import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function getParameterByName(name: string, urlFragment?: string): string {
  // Usa window.location.href se urlFragment não for fornecido
  const fullUrl = urlFragment || window.location.href;
  const url = fullUrl.split('#')[1] || '';
  const nameEscaped = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + nameEscaped + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  return results ? decodeURIComponent(results[2].replace(/\+/g, ' ')) : null;
}


/**
 * Recebe uma função assíncrona (asyncFunction) e retorna
 * outra função que, caso seja chamada várias vezes em paralelo,
 * reutilizará a mesma Promise enquanto estiver em execução.
 *
 * Assim, apenas a primeira chamada executa de fato; as demais
 * recebem a mesma Promise e aguardam.
 */
export function singleExecution<T>(asyncFunction: () => Promise<T>): () => Promise<T> {
  let currentPromise: Promise<T> | null = null;

  return async (): Promise<T> => {
    if (currentPromise) {
      console.log("Já está em execução");
      // Se já está sendo executado, retorna a mesma Promise
      return currentPromise;
    }
    // Executa a função assíncrona e guarda a Promise
    currentPromise = asyncFunction();
    try {
      const result = await currentPromise;
      return result;
    } finally {
      // Quando terminar (com sucesso ou erro), libera para nova execução
      currentPromise = null;
    }
  };
}

export function setNewParameter(key: string, value: string): boolean {
  try {
    const fullUrl = window.location.href;
    const fragment = fullUrl.split('#')[1] || '';
    const baseUrl = fullUrl.split('#')[0];
    const [path, queryString] = fragment.split('?');

    const params = new URLSearchParams(queryString || '');

    if (value) {
      // Add or update the key
      params.set(key, value);
    } else {
      // If no value is provided, remove the key
      params.delete(key);
    }

    const newFragment = params.toString() ? `${path}?${params.toString()}` : path;

    // Update the URL without reloading the page
    window.history.replaceState({}, '', `${baseUrl}#${newFragment}`);
    return true;
  } catch {
    return false;
  }
}

export function isNewClientOrUser(value: string): boolean {
  return typeof value === "undefined" || value === null || value === "new" || value === ""
}

export function cpfValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let cpf = control.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    cpf = cpf.padStart(11, '0'); // Garante que tenha 11 caracteres, preenchendo com '0' à esquerda, se necessário
    cpf = cpf.substring(cpf.length - 11); // Pega apenas os 11 primeiros caracteres

    if (!cpf) return null; // retorna válido se o campo estiver vazio
    if (cpf.length < 4) return { cpfInvalid: true };

    // Verifica se o CPF contém apenas números
    if (!/^\d+$/.test(cpf)) return { cpfNotNumeric: true };

    // Adiciona zeros à esquerda se o CPF tiver menos de 11 dígitos
    cpf = cpf.padStart(11, '0');

    // Verificação de CPFs conhecidos como inválidos mas que passam na validação matemática
    if (["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"].includes(cpf)) {
      return { cpfInvalid: true };
    }

    for (let j = 0; j < 2; j++) {
      let soma = 0;
      for (let i = 0; i < 9 + j; i++) {
        soma += parseInt(cpf.charAt(i)) * ((10 + j) - i);
      }
      let checkDigit = 11 - (soma % 11);
      if (checkDigit === 10 || checkDigit === 11) checkDigit = 0;
      if (checkDigit !== parseInt(cpf.charAt(9 + j))) return { cpfInvalid: true };
    }

    return null; // CPF válido
  };
}

// Função que retorna um ValidatorFn
export function containsCharacterValidator(Character: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    const containsDot = value.includes(Character); // Verifica se contém o ponto
    return containsDot ? null : { 'noDot': { value: control.value } }; // Se contém, retorna null, senão retorna um objeto de erro
  };
}

export function formatarNumero(numero: number): string {
  // Formata o número com duas casas decimais usando a função toLocaleString()
  console.log(numero)
  let numeroFormatado = numero.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  console.log(numeroFormatado)

  // Verifica se o número já tem duas casas decimais
  const indexPonto = numeroFormatado.indexOf(',');
  if (indexPonto !== -1) {
    const casasDecimais = numeroFormatado.length - indexPonto - 1;
    if (casasDecimais === 1) {
      // Se tiver apenas uma casa decimal, adiciona um zero à direita
      numeroFormatado += '0';
    }
  } else {
    // Se não houver separador decimal, adiciona ',00' no final
    numeroFormatado += ',00';
  }

  // Substitui o ponto por vírgula
  numeroFormatado = numeroFormatado.replace('.', ',');

  return numeroFormatado;
}

export function toNumberIfNotNull(value: any): any {
  if (value === null || value === '' || value === 0) {
    return null
  } else {
    return Number(value.replace(/\D/g, ''))
  }
}

export function toDateIfNotNull(date: any): any {
  if (date === null || date === '') {
    return null
  } else {
    return date.toISOString().split('T')[0]
  }
}